<template>
    <div class="col">
        <ComboCard :combo="combo"/>
    </div>
</template>

<script>
    import ComboCard from './../../ComboCard.vue';

    export default {
        components: { ComboCard },

        props: ['combo'],
    };
</script>
